import { WarningTriangleIcon } from "@xola/icons";
import { Alert } from "@xola/ui-kit";
import React from "react";
import { PaymentMethod, Seller, SellerPaymentMethod } from "types";
import { getPaymentMethodName } from "../../../models/Payment";

interface DifferentPaymentWarningProps {
    paymentMethod: SellerPaymentMethod | null;
    initialPaymentMethod: SellerPaymentMethod | null;
    seller: Seller;
}

export const DifferentPaymentWarning = ({
    paymentMethod,
    initialPaymentMethod,
    seller,
}: DifferentPaymentWarningProps) => {
    const isInitialCreditCard = initialPaymentMethod?.id === PaymentMethod.CREDIT_CARD;
    const isNewStoreCredit = paymentMethod?.id === PaymentMethod.STORE_CREDIT;
    if (isInitialCreditCard && !isNewStoreCredit && initialPaymentMethod.id !== paymentMethod?.id) {
        return (
            <Alert className="flex-0 w-full" color="warning">
                <div className="alert-content-wrapper flex justify-between">
                    <WarningTriangleIcon size="large" className="mr-5 self-center" />
                    <p className="flex-1">
                        You are refunding to a different payment method {paymentMethod!.name} than what was originally
                        used to make this purchase {getPaymentMethodName(seller, initialPaymentMethod.id)}
                    </p>
                </div>
            </Alert>
        );
    }

    return null;
};
